import { RouterStore } from '@superwf/mobx-react-router';
import { LabelProvider, Main } from 'telia-front-react';
import { createBrowserHistory } from 'history';
import { observer, Provider } from 'mobx-react';
import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import FooterContainer from './components/footer/FooterContainer';
import HeaderContainer from './components/header/HeaderContainer';
import MainContentContainer from './MainContentContainer';
import RootStore from './stores/RootStore';
import DiilThemeProvider from './wrapper/DiilThemeProvider';

const browserHistory = createBrowserHistory();

@observer
class App extends React.Component {
  private readonly rootStore: RootStore;

  constructor(props: unknown) {
    super(props);
    const routerStore: RouterStore = new RouterStore(browserHistory);
    this.rootStore = new RootStore(routerStore, window.INITIAL_STATE);
  }

  public render(): JSX.Element {
    const { isCookiebotEnabled, cookieConsents } = this.rootStore.cookieConsentStore;

    return (
      <Provider {...this.rootStore}>
        <BrowserRouter>
          <DiilThemeProvider>
            <LabelProvider labels={this.rootStore.translateStore.globalTranslations}>
              <Main consentEnabled={isCookiebotEnabled} consent={{ ...cookieConsents }}>
                <HeaderContainer />
                <MainContentContainer />
                <FooterContainer />
              </Main>
            </LabelProvider>
          </DiilThemeProvider>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
